import { render, staticRenderFns } from "./WidgetNewCampaigns.vue?vue&type=template&id=2c83af17"
import script from "./WidgetNewCampaigns.vue?vue&type=script&lang=js"
export * from "./WidgetNewCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports